import { api } from "@/utils/api";
import { loginUser } from "../../../../features/user/userSlice";
import { toast } from "@/utils/appToast";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import type { User } from "../../../../types/userTypes";
import Select from 'react-select';
import { createMetaConversionPayload, fireMetaPixelEvent } from "@/utils/metaPixel";

export function RegisterForm({ isWorker }: { isWorker: boolean }) {
  const { i18n } = useTranslation();
const [services, setServices] = useState([]);
const [selectedRegions, setSelectedRegions] = useState<string[]>([]);
const [selectedService, setSelectedService] = useState<string>("");
const [otherService, setOtherService] = useState<string>("");
const [availability, setAvailability] = useState<string>("");
const [regions, setRegions] = useState([]);
const [serviceCategories, setServiceCategories] = useState([]);
const [selectedCategoryId, setSelectedCategoryId] = useState<string>("");
const [categoryServices, setCategoryServices] = useState([]);
const [groupedRegionOptions, setGroupedRegionOptions] = useState<any[]>([]);
const [selectedMunicipalities, setSelectedMunicipalities] = useState<any[]>([]);

  useEffect(() => {
 const fetchOptions = async () => {
  try {
    const fetchedRegions = await api.getRegions();
    const fetchedServiceCategories = await api.getServiceCategories();

    setRegions(fetchedRegions);
    setServiceCategories(fetchedServiceCategories);

    // Transform regions into grouped options for react-select
    const grouped = fetchedRegions.map(region => ({
      label: region.name,
      options: region.municipalities.map(muni => ({
        value: `${region._id}:${muni}`,
        label: muni,
        regionId: region._id,
        regionName: region.name
      }))
    }));
    setGroupedRegionOptions(grouped);
  } catch (err) {
    console.error("Failed to fetch options:", err);
  }
};


  fetchOptions();
}, [i18n.language]);


useEffect(() => {
  const selectedCategory = serviceCategories.find(cat => cat._id === selectedCategoryId);
  setCategoryServices(selectedCategory?.services || []);
}, [selectedCategoryId, serviceCategories]);


  const closeModal = useRef();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  // const navigate = useNavigate();
  // const dispatch = useDispatch();

  const handleRegister = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    // Validate that at least one region/municipality is selected
    if (!selectedRegions || selectedRegions.length === 0) {
      toast.error("Seleccione al menos una región/municipio.");
      return;
    }

    const closeModalBtn = closeModal.current as HTMLButtonElement;
    const registerForm = e.target as HTMLFormElement;
    const registerData = new FormData(registerForm);     // single value
const selectedServices = registerData.get("services") as string;
//const selectedRegions = registerData.getAll("regions").map(r => r as string);
const selectedAvailability = registerData.get("availability") as string;
const isCompany = registerData.get("isCompany") as string


    if (registerData.get("password") !== registerData.get("repeatPassword")) {
      toast.error("¡Las contaseñas no coinciden!");
      return;
    }
        const password = registerData.get("password") as string;
    if (password.length < 6) {
      toast.error("La contraseña debe tener al menos 6 caracteres.");
      return;
    }
    // Transform selectedRegions to grouped format
    const groupedRegions: { id: string; subregions: string[] }[] = [];
    selectedRegions.forEach((item) => {
      const [regionId, subregion] = item.split(":");
      const existing = groupedRegions.find(r => r.id === regionId);
      if (existing) {
        existing.subregions.push(subregion);
      } else {
        groupedRegions.push({ id: regionId, subregions: [subregion] });
      }
    });
    let newUser;
    if(isWorker){
     newUser = {
      first_name: registerData.get("first_name") as string,
      last_name: registerData.get("last_name") as string,
      email: registerData.get("email") as string,
      password: registerData.get("password") as string,
      phone: `+${registerData.get("phone-prefix")}${registerData.get("phone")}`,
      type: isWorker ? "worker" : undefined,
      service: selectedService !== "other" ? selectedServices : undefined,
      otherService: selectedService === "other" ? otherService : undefined,
      serviceCategory: selectedCategoryId || undefined, 
      regions: groupedRegions,           
      availability: selectedAvailability,
      isCompany
    };
  }else{
     newUser = {
      first_name: registerData.get("first_name") as string,
      last_name: registerData.get("last_name") as string,
      email: registerData.get("email") as string,
      password: registerData.get("password") as string,
      phone: `+${registerData.get("phone-prefix")}${registerData.get("phone")}`,
      type: isWorker ? "worker" : undefined,
      regions: groupedRegions,           
    };
  }
    console.log("new user data, ",newUser)

    setIsLoading(true);
    const meta = createMetaConversionPayload();
    const { status, data } = await api.signUp({
      ...newUser,
      ...meta,
    });
  

    setIsLoading(false);

    if (status === "error") return toast.error(data.message);

    fireMetaPixelEvent("CompleteRegistration", meta.eventId);

  //  const { token, user } = data;
   // dispatch(loginUser({ token, user }));
    toast.success("Usuario creado exitosamente. Gracias por registrarse.");

    registerForm.reset();
    setSelectedCategoryId("");
    setSelectedService("");
    setOtherService("");
    setSelectedMunicipalities([]);
    setSelectedRegions([]);
    setAvailability("");
    closeModalBtn.click();    

  //  if (isWorker) navigate("/update-worker");
  };

  const fields = [
    {
      id: "registerUserName",
      type: "text",
      name: "first_name",
      placeholder: "Nombre",
      label: "Nombre",
    },
    {
      id: "registerUserLastname",
      type: "text",
      name: "last_name",
      placeholder: "Apellido",
      label: "Apellido",
    },
    {
      id: "registerUserEmail",
      type: "text",
      name: "email",
      placeholder: "Email",
      label: "Email",
    },
    {
      id: "registerUserPhone",
      type: "number",
      name: "phone",
      isPhone: true,
      placeholder: "Teléfono",
      label: "Teléfono",
    },
    {
      id: "registerUserPassword",
      type: "password",
      name: "password",
      placeholder: "Contraseña",
      label: "Contraseña",
    },
    {
      id: "registerUserRepeatPassword",
      type: "password",
      name: "repeatPassword",
      placeholder: "Repetir Contraseña",
      label: "Repetir Contraseña",
    },
  ];

  return (
    <>
      <form onSubmit={handleRegister}>
        <div className="form-group">
          {/* First Name and Last Name in same row */}
          <div className="row mb-5">
            <div className="col-md-6">
              <div className="form-group">
                <label htmlFor="registerUserName" style={{ color: "white" }}>
                  Nombre        
                </label>
                <input
                  id="registerUserName"
                  name="first_name"
                  type="text"
                  placeholder="Nombre"
                  style={{ borderRadius: 0 }}
                  required
                />
              </div>
            </div>
            <div className="col-md-6">           
              <div className="form-group">
                <label htmlFor="registerUserLastname" style={{ color: "white" }}>
                  Apellido
                </label>
                <input
                  id="registerUserLastname"
                  name="last_name"
                  type="text"
                  placeholder="Apellido"
                  style={{ borderRadius: 0 }}
                  required
                />
              </div>
            </div>
          </div>

          {/* Rest of the fields */}
          {fields.slice(2).map((field) => (
            <div key={field.id} className="form-group">
              <label htmlFor={field.id} style={{ color: "white" }}>
                {field.label}
              </label>
              <div className="d-flex gap-2">
                {field.isPhone && (
                  <select
                    id={`${field.id}-prefix`}
                    name="phone-prefix"
                    className="form-select"
                    style={{ flex: 1, borderRadius: 0 }}
                  >
                    <option value="1">+1</option>
                    <option value="54">+54</option>
                     <option value="92">+92</option>
                  </select>
                )}
                <input
                  id={field.id}
                  name={field.name}
                  type={field.type}
                  placeholder={field.placeholder}
                  style={{ flex: 6, borderRadius: 0 }}
                  required
                />
              </div>
            </div>
          ))}

          {/* Is Company Select */}
{  isWorker && <div className="form-group">
  <label htmlFor="isCompany" style={{ color: "white" }}>
    ¿Eres una persona individual o una empresa?
  </label>
  <select
    id="isCompany"
    name="isCompany"
    className="form-select"
    required
  >
    <option value="">Seleccionar</option>
    <option value="Individual">Individual</option>
    <option value="Company">Empresa</option>
  </select>
</div>}
      {/* Select Category */}


{  isWorker && <div className="form-group">
  <label style={{ color: "white" }}>Categoría de Servicio</label>
  <select
    className="form-select"
    required
    value={selectedCategoryId}
    onChange={(e) => {
      setSelectedCategoryId(e.target.value);
      setSelectedService(""); // reset service
    }}
  >
    <option value="">Seleccionar Categoría</option>
    {serviceCategories.map((category) => (
      <option key={category._id} value={category._id}>
        {category.name}
      </option>
    ))}
  </select>
</div>}

{/* Select Service */}
{ isWorker && <div className="form-group">
  <label style={{ color: "white" }}>Servicio</label>
  <select
    name="services"
    className="form-select"
    required
    value={selectedService}
    onChange={(e) => setSelectedService(e.target.value)}
    disabled={!selectedCategoryId} // ✅ disables the dropdown if no category is selected
  >
    <option value="">Seleccionar Servicio</option>

    {categoryServices.map((service) => (
      <option key={service._id} value={service._id}>
        {service.name}
      </option>
    ))}

    <option value="other">Otro</option>
  </select>
</div>}


{/* Show otherService input if selected */}
{selectedService === "other" && (
  <div className="form-group">
    <label style={{ color: "white" }}>Otro Servicio</label>
    <input
      type="text"
      name="otherService"
      className="form-control"
      placeholder="Ingresa otro servicio"
      value={otherService}
      onChange={(e) => setOtherService(e.target.value)}
      required
    />
  </div>
)}
{/* Regions Select (Multi-Select) */}

<div className="form-group">
  <label style={{ color: "white" }}>Regiones</label>
  <Select
    isMulti
    name="regions"
    options={groupedRegionOptions}
    className="basic-multi-select"
    classNamePrefix="select"
    value={selectedMunicipalities}
    onChange={(selectedOptions) => {
      setSelectedMunicipalities(Array.isArray(selectedOptions) ? selectedOptions : []);
      setSelectedRegions(Array.isArray(selectedOptions) ? selectedOptions.map(opt => opt.value) : []);
    }}
    placeholder="Seleccione una o varias regiones"
    closeMenuOnSelect={false}
    styles={{
      control: (base) => ({
        ...base,
        borderColor: "#ccc",
        color: "#696969",  
        minHeight:'60px',
        borderRadius:'7px',
        backdropFilter:'none',
        backgroundColor: '#f3f3f3',
        border: '1px solid #f0f5f7'
      }),
      input: (base) => ({
        ...base,
        color: "#696969"
      }),
      placeholder: (base) => ({
        ...base,
        color: "#696969",
        paddingLeft:10,
        fontSize:15
      }),
      singleValue: (base) => ({
        ...base,
        color: "#000"
      }),
      option: (base, state) => ({
        ...base,
        backgroundColor: state.isFocused ? "#f0f0f0" : "#fff",
      }),
      multiValue: (base) => ({
        ...base,
        backgroundColor: "#f0f0f0",
        color:'#696969'
      }),
      multiValueLabel: (base) => ({
        ...base,
        color: "#696969"
      }),
      multiValueRemove: (base) => ({
        ...base,
        color: "#555",
        ':hover': {
          backgroundColor: '#ddd',
          color: '#000'
        }
      })
    }}
  />
</div>



{/* Availability Dropdown */}
{isWorker && <div className="form-group">
  <label htmlFor="availability" style={{ color: "white" }}>
    Disponibilidad
  </label>
  <select
    id="availability"
    name="availability"
    className="form-select"
    value={availability}
    onChange={(e) => setAvailability(e.target.value)}
    required
  >
    <option value="" disabled>Seleccionar disponibilidad</option>
    <option value="Monday to Friday">Lunes a Viernes</option>
    <option value="Saturday to Sunday">Sábado a Domingo</option>
    <option value="Every day">Todos los días</option>
  </select>
</div>}
          <button
            className="theme-btn btn-style-one"
            type="submit"
            disabled={isLoading}
            style={{ backgroundColor: "black" }}
          >
            {isLoading ? (
              <div
                className="spinner-border"
                style={{ height: "15px", width: "15px" }}
                role="status"
              ></div>
            ) : (
              "Registrarme"
            )}
          </button>
        </div>
      </form>

      <button
        className="d-none hidden"
        data-bs-toggle="modal"
        data-bs-dismiss="modal"
        ref={closeModal}
      >
        Cerrar Modal
      </button>
    </>
  );
}
